import React from 'react'
import {motion} from 'framer-motion'
import styles from '../styles/Contact.module.css';
import multicolor from '../assets/multicolor.webp';

import Title from '../components/Title';

const Contact = () => {

  const fadeVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 }
  };

  return (
    <>
    <motion.div
        variants={fadeVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.5, easeOut: "easeOut" }}
      >
      <Title title='Contact' subtitle='Me' />
      <div className={styles.contactContainer} id='next-section'>
        <img className={styles.colorChart} src={multicolor} alt='multi-colour hair' />
        <div className={styles.colorOverlay}></div>
        <div className={styles.formContainer}>
          <div style={{textAlign: "center", marginBottom: "10px", color: "#f0f0f0ff"}}>
            <h1 style={{marginTop: "1.5rem"}}>Let's talk about your <span style={{fontSize: "1.1em", fontWeight: 600, padding: "0 7px", backgroundColor: "#cffc1c", color: "#5e5e5e"}}>Haircare</span> needs...</h1>
          </div>
          <div style={{textAlign: "center", fontSize: "1.1em", color: "#f0f0f0ff", marginBottom: "20px"}}>
            <p>Whether its maintenance, a new you or a colour correction, I am here to help.</p>
          </div>
          <div className={styles.buttonContainer}>
              {/* <a
                className={styles.socialButton}
                href='https://wa.me/7799212929?text=Hi%20Kara'
                target='_blank' rel='noreferrer' alt="Message Kara via WhatsApp">
                <i class="fa-brands fa-whatsapp"></i>
                Chat on WhatsApp
              </a> */}
              <a
                className={styles.socialButton}
                href='mailto:me@karahaircare.co.uk?subject=Haircare%20consultation%20enquiry?Body=Hi%20Kara%20'
                alt="Send an email to Kara"
                target='_blank' rel='noreferrer'>
                <i class="fa-regular fa-envelope"></i>
                Message via Email
              </a>
              <a
                className={styles.socialButton}
                href='https://www.instagram.com/kara__haircare_'
                target='_blank' rel='noreferrer' alt="link to Kara's Instagram">
                <i class="fa-brands fa-instagram"></i>
                Follow on Instagram
              </a>
              <a
                className={styles.socialButton}
                href='https://www.tiktok.com/@kara_hair_care'
                target='_blank' rel='noreferrer' alt="link to Kara's Tik Tok">
                <i class="fa-brands fa-tiktok"></i>
                Follow on TikTok
              </a>
          </div>
        </div>
      </div>
      </motion.div>
    </>
  )
}

export default Contact